import styled from "@emotion/styled";

import Select from "metabase/core/components/Select";

export const FontSelect = styled(Select)`
  flex: 1 1 auto;
  max-width: 25rem;
`;
